import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ContactReachService } from '../../services/raintree/Transmission/contact-reach.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import {Clipboard} from '@angular/cdk/clipboard';
import { VisitTransmissionService } from '../../services/raintree/Transmission/visit-transmission.service';
@Component({
  selector: 'app-contact-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, LoaderComponent,],
  templateUrl: './contact-dialog.component.html',
  styleUrl: './contact-dialog.component.scss',
})
export class ContactDialogComponent {
  constructor(
    private toaster: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private contactService: ContactReachService,
    private visitTransmission:VisitTransmissionService,
    private clipboard: Clipboard
  ) { }
  phnNumber: string = '';
  isLoading: boolean = false;
  //toggle number and button
  checkNumber: boolean = false;
  showNumber(): void {
    let reqData: any = {
      memKey: this.data?.slno || this.data?.SL_NO,
      agreed_tnc: true,
    };
    this.isLoading = true;
    // console.log(this.data, 'data');
    if (this.data.type) {
      // console.log('areYouUpdated reqData',reqData);

      this.contactService.getPhnNumberAreYouUpdated(reqData).subscribe({
        next: (response: any) => {
          this.phnNumber = response.data;
          this.isLoading = false;
          this.checkNumber = true;
          this.toaster.success('Contact fetched successfully');
        },
        error: (error) => {
          this.isLoading = false;
          console.log(error);
          this.toaster.error(error);
        },
      });
    }
    else if(this.data.from&&this.data.from==='PM-visited'){
      // console.log('visited contact payload',this.data);
      
      this.visitTransmission.accessVisitedContact(this.data).subscribe({
        next:(response)=>{
          console.log(response);
          if(response.error){
            this.toaster.error(response.message,'Error')
            console.log(response.error);
            this.isLoading=false;
          }
          else{
            this.phnNumber = response.data;
            this.isLoading = false;
            this.checkNumber = true;
            this.toaster.success(response.message,'Success');
          }
        },
        error: (err)=>{
          this.isLoading=false;
          console.log(err);
          this.toaster.error(err,'Error');
        }
      });
    } 
    else {
      reqData = {
        ...reqData, uiState: this.data?.state_name,
        uiDistrict: this.data?.district
      }
      // console.log('contact service reqData->',reqData);
      
      this.contactService.getPhnNumber(reqData).subscribe({
        next: (response: any) => {
          this.phnNumber = response.data.value;
          this.isLoading = false;
          this.checkNumber = true;
          this.toaster.success('Contact fetched successfully');
        },
        error: (error) => {
          this.isLoading = false;
          console.log(error);
          this.toaster.error(error);
        },
      });
    }
  }

  copyToClipboard(){
    this.clipboard.copy(this.phnNumber);
    this.toaster.success("Contact number copied to clipboard")
  }
}
// }
